/* eslint-disable import/prefer-default-export */
import { css } from 'styled-components';
import { KineduPalette } from 'kinedu-react-components';

export const Basic = {
  container: css`
    margin: auto;
  `,
  input: css`
    color: ${KineduPalette.shadeDark};
    background: transparent;
    border: none;
    border-bottom: 1px solid ${KineduPalette.shadeMediumLight};
    box-shadow: none;

    width: 100%;
    height: 30px;
    padding: 5px 0 0 12px;
    box-sizing: border-box;

    font-size: 24px;
    font-weight: 500;
    text-align: left;
    letter-spacing: -0.36px;

    transition: all .20s ease-in-out;
    outline: none;

    &:focus {
      color: ${KineduPalette.newKinedu};
      border-bottom: 1px solid ${KineduPalette.newKinedu};
    }
  `,
  disabled: css`
    opacity: 0.4;
  `,
  placeholder: css`
    color: ${KineduPalette.shadeMedium};
  `,
  label: css`
  display: block;
    margin-bottom: 10px;

    color: ${KineduPalette.shadeDark};
    text-transform: uppercase;
    text-align: left;

    font-size: 20px;
    font-weight: 400;
    letter-spacing: 5px;
`,
};

export const Rounded = {
  container: css`
    margin: auto;
  `,
  input: css`
    color: ${KineduPalette.newKinedu};
    background: transparent;
    border: 1px solid ${KineduPalette.newKinedu};
    border-radius: 20px;
    box-shadow: none;

    width: 100%;
    height: 40px;
    padding: 0 0 0 30px;
    box-sizing: border-box;

    font-size: 15px;
    font-weight: 500;
    text-align: left;
    letter-spacing: -0.36px;

    transition: all .20s ease-in-out;
    outline: none;

    &:focus {
      color: ${KineduPalette.newKinedu};
      border-bottom: 1px solid ${KineduPalette.newKinedu};
    }
    `,
  placeholder: css`
    color: ${KineduPalette.newKinedu};
    font-size: 15px;
    font-weight: 500;
    font-style: italic;
    `,
  label: css`
    display: block;
    margin: 10px;

    color: ${KineduPalette.shadeDark};
    text-transform: uppercase;
    text-align: left;

    font-size: 20px;
    font-weight: 400;
    letter-spacing: 5px;
`,
};

export const Underlined = {
  wrapper: css`
    margin: 20px 0;
  `,
  input: css`
    color: ${KineduPalette.shadeDark};
    background: transparent;
    border: none;
    border-bottom: 1px solid ${KineduPalette.shadeMediumLight};
    box-shadow: none;

    width: 100%;
    height: 40px;
    padding: 0px;
    box-sizing: border-box;

    font-size: 24px;
    font-weight: normal;
    text-align: left;
    letter-spacing: -0.6px;

    transition: all .20s ease-in-out;
    outline: none;

    &:focus {
      border-bottom: 1px solid ${KineduPalette.newKinedu};
    }
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active  {
      transition: background-color 9999s ease-in-out 0s;
      -webkit-text-fill-color: #fff !important;
      font-size: 24px;
    }
  `,
  disabled: css`
    opacity: 0.4;
  `,
  placeholder: css`
    color: ${KineduPalette.shadeMedium};
    font-size: 24px;
  `,
  label: css`
    display: block;

    color: ${KineduPalette.shadeDark};
    text-align: left;
    letter-spacing: -0.4px;

    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0px;
  `,
  error: css`
    color: ${KineduPalette.health};
    font-size: 14px;
  `,
};

export const RoundedFlat = {
  wrapper: css`
    display: flex;
    align-items: center;
  `,
  input: css`
    color: ${KineduPalette.shadeDark};
    background: white;
    border: 1px solid ${KineduPalette.shadeMedium};
    border-radius: 20px;
    box-shadow: none;

    width: 100%;
    height: 40px;
    padding: 0 0 0 30px;
    box-sizing: border-box;

    font-size: 15px;
    font-weight: 500;
    text-align: left;
    letter-spacing: -0.36px;
    outline: none;

    &:focus {
      color: ${KineduPalette.shadeDark};
    }
    `,
  placeholder: css`
    font-size: 14px;
    color: ${KineduPalette.shadeMediumDark};
    letter-spacing: 0;
    line-height: normal!important;
  `,
  label: css`
    display: block;
    margin: 10px;

    color: ${KineduPalette.shadeDark};
    text-transform: uppercase;
    text-align: left;

    font-size: 20px;
    font-weight: 400;
    letter-spacing: 5px;
  `,
  slot: css`
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 100%;
  `,
};

interface IThemes {
  [key: string]: any;
}

const TexterThemes: IThemes = {
  Basic,
  Rounded,
  Underlined,
  RoundedFlat,
};

export default TexterThemes;
